import { RootState } from '../../reducers';

const selectOffers = (state: RootState) => state?.offers?.offers || null;

export default selectOffers;
